<script lang="ts">
  import type { FormField } from '../types';
  import { resetField } from '$lib/helpers/form-field-reset';

  export let field: FormField;
  export let inputValue: string;
  export let isError: boolean = false;

  let inputTextAreaElement: HTMLTextAreaElement;

  const handleClick = () => {
    inputTextAreaElement.focus();
  };
</script>

<div class="marketInput" class:isError>
  <textarea
    bind:this={inputTextAreaElement}
    bind:value={inputValue}
    placeholder={field.placeholder || ' '}
    id={field.id}
    name={field.id}
    autocomplete={field.autocompleteType}
    required={field.required}
    use:resetField
    on:click={handleClick}
  />
  {#if field.label}
    <label for={field.id}>{field.label || field.placeholder}</label>
  {/if}
</div>

<style lang="scss">
  @layer standard-components {
    .marketInput {
      --field-label-top-position: -79px;
      --field-textarea-top-position: 24px;

      height: var(--field-textarea-height);
      flex-flow: column;

      label {
        top: var(--field-label-top-position);
        position: relative;
      }

      textarea {
        position: relative;
        top: var(--field-textarea-top-position);
        height: calc(100% - var(--field-textarea-top-position));
      }
    }
  }
</style>
